<template>
  <div class="process-bound">
    <el-form class="form">
          <div class="bound">
            <div class="title">{{boundIndex===0 ?'默认抄送':"抄送"+ boundIndex}}</div>
            <div class="process-content">
              <div class="target">
                <el-form-item label="绑定流转" >
                  <el-select v-model="bound.boundConnections" multiple collapse-tags disabled>
                    <el-option v-for="(connection, index) in allConnections" :key="connection.id" :label="connection.defaultLine?'默认流转':'流转'+index" :value="connection.id"></el-option>
                  </el-select>
                </el-form-item>
                 <el-form-item label="抄送人员" class="people">
                  <el-select :value="boundpeopleType" @change="changeBoundpeoples">
                    <el-option label="控件" value="component"></el-option>
                    <el-option label="自定义" value="user"></el-option>
                  </el-select>
                  <label class="show-people"
                    v-for="(people, index) in bound.boundPeoples"
                    :key="people.id"
                    :title="people.name"
                    v-if="index < 3">{{people.name}}<label v-if="index===2">...</label></label>
                  <el-button v-show="boundpeopleType==='user'" @click="selectPerson('user',boundIndex)">选择</el-button>
                </el-form-item>
              </div>
            </div>
          </div>
      </el-form>
      <bound-select-people :selectPersonDialog="selectPersonDialog" @saveBoundSelectPerson="saveBoundSelectPerson"></bound-select-people>
  </div>
</template>
<script>
import BoundSelectPeople from './bound-select-people'
export default {
  name: 'process-notice-send',
  props: ['definition', 'bound', 'boundIndex', 'currentNodeId', 'nodes', 'connections'],
  components: {
    BoundSelectPeople
  },
  data () {
    let boundpeopleType = ''
    if (this.bound.boundPeoples && this.bound.boundPeoples.length > 0) {
      switch (this.bound.boundPeoples[0].type) {
        case 'user':
        case 'group':
        case 'department':
          boundpeopleType = 'user'
          break
        case 'component':
          boundpeopleType = 'component'
          break
      }
    }
    return {
      boundpeopleType,
      selectPersonDialog: {
        dialogVisible: false,
        allPerson: [],
        selectType: 'user',
        boundPeoples: []
      }
    }
  },
  methods: {
    selectPerson (way, boundIndex) {
      this.selectPersonDialog.selectType = 'user'
      this.selectPersonDialog.allPerson = []
      // 因为通过的选人面板用的是targetId,为了公用所以吧id变成targetId
      this.selectPersonDialog.boundPeoples = []
      this.bound.boundPeoples.forEach(m => {
        this.selectPersonDialog.boundPeoples.push({'type': m.type, 'targetId': m.id, 'name': m.name})
      })
      this.selectPersonDialog.dialogVisible = true
      this.selectPersonDialog.boundIndex = boundIndex
    },
    saveBoundSelectPerson (boundPeoples) {
      this.bound.boundPeoples = boundPeoples
      this.$emit('saveBound', {boundIndex: this.selectPersonDialog.boundIndex, bound: this.bound})
    },
    changeBoundpeoples (value) {
      this.bound.boundPeoples = [{'type': value, 'id': '', 'name': ''}]
    }

  },
  watch: {
    bound: {
      handler (val) {
        switch (this.bound.boundPeoples[0].type) {
          case 'user':
          case 'group':
          case 'department':
            this.boundpeopleType = 'user'
            break
          case 'component':
            this.boundpeopleType = 'component'
            break
        }
      },
      deep: true

    }
  },
  computed: {
    getCurrentNode () {
      return this.nodes.find(m => m.id === this.currentNodeId)
    },
    targetNode () {
      return this.nodes.filter(m => m.id !== this.currentNodeId)
    },
    currentNode () {
      return this.nodes.filter(m => m.id === this.currentNodeId)[0]
    },
    allConnections () {
      if (this.getCurrentNode && this.getCurrentNode.noticeNodeId) {
        return this.connections.filter(n => n.sourceNodeId === this.getCurrentNode.noticeNodeId)
      }
    }

  }

}
</script>

<style lang="scss">
.process-bound {
  .form {
    .bound {
      background: #fff;

      &:hover {
        background: #F4F9FD;
      }

      .title {
        background: var(--light-9, #EBF5FF);
        height: 27px;
        line-height: 27px;
        padding-left: 9px;
        position: relative;

        .close {
          position: absolute;
          top: 7px;
          right: 10px;
          color: #6BB7F3;
        }
      }

      .process-content {
        padding: 16px 8px 5px;

        .el-form-item__label
          {
          font-size: 12px;
          padding: 0 8px 0 0;
        }

        span {
          font-size: 12px;
        }
        .target {
          .el-select {
            width: 150px;
          }
          .people {
            button {
              padding: 6px 4px;
              margin-left: 10px;
              span {
                font-size: 12px;
                color: #54ABF1
              }
            }
            .show-people {
              margin-right: 12px;
              font-size: 12px;
            }
            .el-input__suffix {
              right: 0px;
              top: 3px;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/process/design/process-notice-send.vue